import { ACTION_TYPES } from 'app/redux/features/pad-initialization/actions/padInitialization.types';

const { SCHEDULE_PRESCRIPTION_INCOMPATIBLE_LINK_MODAL } = ACTION_TYPES;

const initialState = () => ({
  isOpened: false
});

const reducer = (state = initialState(), reduxAction) => {
  switch (reduxAction.type) {
    case `${SCHEDULE_PRESCRIPTION_INCOMPATIBLE_LINK_MODAL}_OPEN`: {
      return {
        ...state,
        isOpened: true
      };
    }
    case `${SCHEDULE_PRESCRIPTION_INCOMPATIBLE_LINK_MODAL}_CLOSE`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
